export const ensureValidHexColor = (color: string, defaultColor = '#111827'): string => {
  try {
    // Remove hash if present
    let hex = color.replace('#', '');

    // Check if hex contains only valid characters
    if (!/^[0-9A-Fa-f]+$/.test(hex)) {
      console.warn(`Invalid hex characters in color: ${color}`);
      return defaultColor;
    }

    // Pad with zeros if too short
    while (hex.length < 6) {
      hex = hex.padStart(6, '0');
    }

    // Truncate if too long
    hex = hex.slice(0, 6);

    return '#' + hex;
  } catch (error) {
    console.error('Error processing color:', error);
    return defaultColor;
  }
};

export const generateRandomColor = (): string => {
  try {
    const hex = Math.floor(Math.random() * 16777215)
      .toString(16)
      .padStart(6, '0');
    return ensureValidHexColor('#' + hex);
  } catch (error) {
    console.error('Error generating random color:', error);
    return '#111827'; // Default dark gray
  }
};
